import type { VideoItem } from "@/types/video";
import { videos } from "@/mocks/videos";

export function getVideoById(id: number): VideoItem | undefined {
  return videos.find((item) => item.id === id);
}

export function getVideosByType(type: "movie" | "tv"): VideoItem[] {
  return videos.filter((item) => item.type === type);
}

export function searchVideos(keyword: string, type: "all" | "movie" | "tv"): VideoItem[] {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return videos.filter((item) => {
    const matchType = type === "all" || item.type === type;
    const haystack = `${item.title} ${item.category} ${item.region} ${item.director} ${item.cast.join(" ")}`.toLowerCase();
    return matchType && haystack.includes(query);
  });
}

export function getRelatedVideos(item: VideoItem, limit = 6): VideoItem[] {
  return videos
    .filter((candidate) => candidate.id !== item.id)
    .map((candidate) => {
      let score = 0;
      if (candidate.category === item.category) score += 4;
      if (candidate.type === item.type) score += 3;
      if (candidate.region === item.region) score += 2;
      score += candidate.rating / 10;
      return { candidate, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((entry) => entry.candidate);
}

export function getHotVideos(ids: number[]): VideoItem[] {
  return ids
    .map((id) => videos.find((item) => item.id === id))
    .filter((item): item is VideoItem => Boolean(item));
}

export function getLatestVideos(limit = 8): VideoItem[] {
  return [...videos]
    .sort((a, b) => b.year - a.year || b.views - a.views)
    .slice(0, limit);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}